import React from "react";
import { Breadcrumb, Icon } from "antd";
import { routes, flatRouteMap } from "router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { get } from "lodash";

const ACTION_PREFIX = "$[action]";
const EditIsCreate = {
  false: "編輯",
  true: "新增",
};

const BreadcrumbWrapper = styled.div`
  background: #0b7252;
  margin: 15px 0;
  padding: 24px;
  position: relative;
  .current-title {
    font-size: 20px;
    color: #e2e2e2;
    margin-top  10px
  }
`;

const handleTitle = (title, isCreate) => {
  return title.indexOf(ACTION_PREFIX) >= 0
    ? title.replace(ACTION_PREFIX, EditIsCreate[isCreate])
    : title;
};

const getName = (current, isCreate) => {
  const route = Object.entries(routes).find(([key, value]) => key === current);
  return handleTitle(get(route, "[1].title"), isCreate);
};
export const breadcurmbs = (current, isCreate = false) => {
  let _routeMap = flatRouteMap[current];
  if (!_routeMap) return <></>;
  const cnt = _routeMap.length;
  return (
    <BreadcrumbWrapper>
      <Breadcrumb>
        {_routeMap.map((rKey, idx) => {
          const r = routes[rKey];
          const title = handleTitle(r.title, isCreate);
          const to = idx === cnt - 1 ? undefined : r.path;
          const iconTitle = (
            <>
              {r.icon ? <Icon type={r.icon} /> : undefined}
              <span>{title}</span>
            </>
          );

          return (
            <Breadcrumb.Item key={rKey}>
              {to ? <Link to={to}>{iconTitle}</Link> : iconTitle}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
      <div className="current-title">{getName(current, isCreate)}</div>
    </BreadcrumbWrapper>
  );
};
